import { useCallback, useEffect, useState } from 'react';
import type { Group } from '@penticton-dev-events/shared';

import { useFirebaseServices } from '../../../app/providers/FirebaseProvider';
import { subscribeToGroups } from '../api/groupRepository';

export type UseGroupsState = {
  readonly groups: Group[];
  readonly loading: boolean;
  readonly error: Error | null;
  readonly refetch: () => void;
};

export const useGroups = (): UseGroupsState => {
  const { firestore } = useFirebaseServices();
  const [groups, setGroups] = useState<Group[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const refetch = useCallback(() => {
    setLoading(true);
    setError(null);
  }, []);

  useEffect(() => {
    console.log('🔔 useGroups: Setting up real-time subscription');
    const unsubscribe = subscribeToGroups(
      firestore,
      nextGroups => {
        console.log('🔔 useGroups: Received group updates:', {
          count: nextGroups.length,
          groupsWithPosters: nextGroups.filter(g => g.posterUrl).map(g => ({
            id: g.id,
            name: g.name,
            hasPosterUrl: !!g.posterUrl,
            posterUrl: g.posterUrl,
          })),
        });
        setGroups(nextGroups);
        setLoading(false);
      },
      subscriptionError => {
        console.error('❌ useGroups: Subscription error:', subscriptionError);
        setError(subscriptionError);
        setLoading(false);
      },
    );

    return () => {
      console.log('🔔 useGroups: Cleaning up subscription');
      unsubscribe();
    };
  }, [firestore]);

  return { groups, loading, error, refetch };
};
